import { MemreFlexBox, MemreIcon, MemreText, IconName } from 'components/core';
import * as color from 'core/colors';
import { useRef, useState } from 'react';
import { darkGray } from 'core/colors';

export default function DragNDrop({ selectedImage, setSelectedImage }) {
  const [dragActive, setDragActive] = useState(false);
  const inputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setSelectedImage(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      setSelectedImage(e.target.files[0]);
    }
  };

  const onButtonClick = () => {
    // @ts-ignore
    inputRef?.current?.click();
  };

  return (
    <div onDragEnter={handleDrag} style={{ width: '100%', height: '100%' }}>
      <input ref={inputRef} type="file" style={{ display: 'none' }} onChange={handleChange} />
      <MemreFlexBox
        direction="column"
        align="center"
        justify="center"
        sx={{
          width: '100%',
          height: '100%',
          backgroundImage: `url(${selectedImage ? URL.createObjectURL(selectedImage) : ''})`,
          backgroundSize: 'cover',
          backgroundColor: dragActive ? color.lightGray : color.veryLightGray,
          borderRadius: 2,
          border: `2px dashed ${color.lightGray}`,
        }}
      >
        <MemreFlexBox
          sx={{ p: 4, backgroundColor: color.hexToRGB(color.veryLightGray, 0.7), borderRadius: 2 }}
          direction="column"
          gap={2}
        >
          <MemreIcon iconName={IconName.save} fontSize="4em" color={color.darkGray} />
          <MemreText variant="h4">
            Drag & Drop Or <button onClick={onButtonClick}>search</button>
          </MemreText>
        </MemreFlexBox>
      </MemreFlexBox>
      {dragActive && (
        <div
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          }}
        />
      )}
    </div>
  );
}
